import React from "react";
import {
  renameKeyAndMergeObject,
  getModifiedKPIName,
  renderColorfulLegendText,
  formatValue,
} from "../utils/utils";
import appConstants from "../../../../../appConstants";
const [Planning] = appConstants.MODULES;
import {
  ResponsiveContainer,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LineChart,
  Legend,
} from "recharts";
import chartConfig from "../ChartConfig";

const CustomLineChart = (props) =>{
  /*
    merge planning, dispatch api data into array of object with modifying some field name,
    after that sorting whole data in increasing date order
  */
  const mergedModuleData = renameKeyAndMergeObject({
    data: props.data,
    groupBy:"planDate",
    keyListWillNotRenamed:["goal"]})
      .sort((a,b) => new Date(a.planDate) - new Date(b.planDate));

  return (
    <ResponsiveContainer>
      <LineChart
        onClick={props.onclick}
        margin={{
          top: 5,
          right: 5,
          left: 10,
          bottom: 10,
        }}
        data={mergedModuleData}
      >
        <CartesianGrid strokeDasharray="3 3"/>
        <XAxis
          dataKey={props.chartConfig.Xkey}
          type="category"
          tickLine={false}
          allowDuplicatedCategory={false}
          // interval={0} //this will allow all date to be displayed on xaxis
        />
        <YAxis/>
        <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px' }} formatter={renderColorfulLegendText} />
        <Tooltip formatter={formatValue} />

        {/* plotting line chat for planning/dispatch data */
        props.data?.map(moduleObj => ( moduleObj.isChecked && 
          <Line dataKey={`${moduleObj.name}_${props.chartConfig.dataKey1}`}
            key={moduleObj.name}
            name={getModifiedKPIName(props.chartConfig.chartlable1, moduleObj.name)} 
            type="monotone"
            connectNulls={true}
            activeDot={{ r: 5 }} 
            stroke={moduleObj.name === Planning
              ? chartConfig.chartColors.planning.color
              : chartConfig.chartColors.dispatch.color
            }
          />))
        }
        
        {/* plotting line chat for planning's goal data */
        props.chartConfig.dataKey2 && props.data.some(ele => ele.isChecked) 
          ? <Line dataKey={props.chartConfig.dataKey2}
              type="monotone"
              connectNulls={true}
              activeDot={{ r: 5 }} 
              stroke={chartConfig.chartColors.planning.goalColor}
              strokeWidth={1.2}
            />
          : null
        }
      </LineChart>
    </ResponsiveContainer>
  )
}

export default CustomLineChart;
